export const CONTEXT_ACCREDITATION_CODE = 'accreditation'
export const CONTEXT_ACCREDITATION_PASSPORT_CODE = 'accreditation-passport'
export const CONTEXT_TRAINING_WISH_CODE = 'training-wish'

type Section = 'session' | 'training' | 'period' | 'participant' | 'block' | 'day' | 'format' | 'accreditation'

export interface DocTemplateContext {
  code: string
  module: 'training' | 'safety' | 'workplace'
  sections?: Section[]
  permission?: string
  canRepeat: boolean
  hasDefault: boolean
}

export const CONTEXTS: DocTemplateContext[] = [
  {
    code: 'session',
    module: 'training',
    sections: ['session', 'training', 'period', 'participant', 'block', 'day', 'format'],
    canRepeat: true,
    hasDefault: false,
  },
  {
    code: CONTEXT_TRAINING_WISH_CODE,
    module: 'training',
    sections: ['session', 'training', 'participant', 'format'],
    canRepeat: false,
    hasDefault: true,
  },
  {
    code: CONTEXT_ACCREDITATION_CODE,
    module: 'safety',
    permission: 'ACCREDITATION_MANAGEMENT',
    sections: ['participant', 'accreditation', 'format'],
    canRepeat: true,
    hasDefault: true,
  },
  {
    code: CONTEXT_ACCREDITATION_PASSPORT_CODE,
    module: 'safety',
    canRepeat: false,
    hasDefault: true,
  },
  {
    code: 'room-booking-sheet',
    module: 'workplace',
    canRepeat: false,
    hasDefault: true,
  },
  {
    code: 'room-booking-planning',
    module: 'workplace',
    canRepeat: false,
    hasDefault: true,
  },
]
export const FORMAT_PDF = 'pdf'
export const FORMATS = ['docx', FORMAT_PDF]
export const REPEAT_MODE_DAY = 'day'
export const REPEAT_MODE_NEVER = 'never'
export const REPEAT_MODE_PARTICIPANT = 'participant'
export const REPEAT_MODE_PERIOD = 'period'

export const REPEAT_MODES = [REPEAT_MODE_NEVER, REPEAT_MODE_PARTICIPANT, REPEAT_MODE_DAY, REPEAT_MODE_PERIOD]
